export const dayRange = 20;
export const cameraPrice = 150;
